// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-deploy-jsx": () => import("/opt/build/repo/src/pages/deploy.jsx" /* webpackChunkName: "component---src-pages-deploy-jsx" */),
  "component---src-pages-index-jsx": () => import("/opt/build/repo/src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */)
}

